import React from 'react'
import {IoFemaleOutline, IoMaleOutline, IoPersonCircleOutline} from 'react-icons/io5'

// GenderTypes (views/AppLocals/appFieldTypes.js): Male=1, Female=2, Others=3 - icon nam/nữ theo
// đúng field gender thay vì icon người chung chung, dùng lại ở mọi nơi hiển thị member trong feature
// Family Book (list Thành Viên, card Cây Gia Phả...) thay vì tự chế icon riêng từng chỗ.
const GenderIcon = ({gender, size = 14, className}) => {
    if (gender === 1) return <IoMaleOutline size={size} className={className}/>
    if (gender === 2) return <IoFemaleOutline size={size} className={className}/>
    return <IoPersonCircleOutline size={size} className={className}/>
}

export default GenderIcon
